import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (deleteAllFuture: boolean) => void;
  title: string;
  message: string;
  showRecurringOption?: boolean;
}

export default function DeleteConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  showRecurringOption = false
}: DeleteConfirmDialogProps) {
  const [deleteAllFuture, setDeleteAllFuture] = React.useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full transform transition-all animate-scaleIn">
        <div className="p-6">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 p-3 rounded-full bg-red-50">
              <AlertTriangle className="w-12 h-12 text-red-500" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600">{message}</p>

            {showRecurringOption && (
              <div className="mt-4 flex items-center">
                <input
                  type="checkbox"
                  id="deleteAllFuture"
                  checked={deleteAllFuture}
                  onChange={(e) => setDeleteAllFuture(e.target.checked)}
                  className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                />
                <label htmlFor="deleteAllFuture" className="ml-2 block text-sm text-gray-900">
                  Delete all future recurring events
                </label>
              </div>
            )}
          </div>

          <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-center space-y-3 space-y-reverse sm:space-y-0 sm:space-x-3">
            <button
              onClick={onClose}
              className="w-full sm:w-auto px-6 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onConfirm(deleteAllFuture);
                onClose();
              }}
              className="w-full sm:w-auto px-6 py-3 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}